import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../logo_colored_transp_no_text.png'; 
import LoginForm from './LoginForm'; 
import { FiMenu, FiX } from 'react-icons/fi'; // ÚJ IMPORT

// --- MÓDOSÍTOTT IMPORTOK: A központi firebase.js-ből használjuk az auth-ot és db-t ---
import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from '../firebase';
import { ALLOWED_UIDS } from '../constants/Whitelist'; // ÚJ IMPORT

const Navbar = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [userData, setUserData] = useState(null); 
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener('resize', handleResize);

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user && ALLOWED_UIDS.includes(user.uid)) {
        setCurrentUser(user);
        try {
          const clubRef = doc(db, "Clubs", user.uid);
          const clubSnap = await getDoc(clubRef);

          if (clubSnap.exists()) {
            const data = clubSnap.data();
            setUserData({
              ...data,
              displayName: data.clubName || data.fullName || "Club",
              type: 'club'
            });
          } else {
            const userRef = doc(db, "users", user.uid);
            const userSnap = await getDoc(userRef);

            if (userSnap.exists()) {
              const data = userSnap.data();
              const isClub = data.role?.toLowerCase() === 'club';
              
              setUserData({
                ...data,
                displayName: isClub 
                  ? (data.clubName || data.fullName || "Egyesület")
                  : (data.name || data.displayName || "Saját profil"),
                type: isClub ? 'club' : 'competitor'
              });
            } else {
              setUserData({ displayName: "Profil", type: 'unknown' });
            }
          }
        } catch (error) {
          console.error("Error fetching data:", error);
          setUserData({ displayName: "Error", type: 'error' });
        }
      } else {
        setCurrentUser(null);
        setUserData(null);
      }
    });
    return () => {
      unsubscribe();
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // NAVIGÁCIÓS FÜGGVÉNY
  const handleProfileNavigation = () => {
    setMobileMenuOpen(false);
    if (!userData) return;
    if (userData.type === 'club') {
      navigate('/egyesulet-dashboard');
    } else {
      navigate('/profil');
    }
  };

  const handleLogout = async () => {
    setMobileMenuOpen(false);
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error("Kijelentkezési hiba:", error);
    }
  };

  const buttonStyle = {
    backgroundColor: 'white',
    color: '#b30000',
    padding: '0.4rem 0.8rem',
    borderRadius: '5px',
    textDecoration: 'none',
    fontWeight: 'bold',
    fontSize: '0.9rem',
    transition: 'all 0.3s ease',
    border: 'none',
    cursor: 'pointer',
    marginLeft: isMobile ? '0' : '10px',
    display: 'inline-block',
    width: isMobile ? '100%' : 'auto',
    textAlign: 'center',
    marginBottom: isMobile ? '10px' : '0'
  };

  const userPageButtonStyle = {
    ...buttonStyle,
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    color: 'white',
    border: '1px solid white',
    opacity: userData ? 1 : 0.7,
    cursor: userData ? 'pointer' : 'wait'
  };

  const logoContainerStyle = {
    backgroundColor: '#ffffff',
    colorScheme: 'light',
    padding: '4px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
    transition: 'transform 0.2s ease',
    marginLeft: '5px',
    lineHeight: 0,
    overflow: 'hidden'
  };

  const handleMouseEnter = (e, isUserBtn) => {
    if (isMobile) return;
    e.target.style.transform = 'scale(1.05)';
    if (!isUserBtn) e.target.style.backgroundColor = '#f2f2f2';
    else e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.25)';
  };

  const handleMouseLeave = (e, isUserBtn) => {
    if (isMobile) return;
    e.target.style.transform = 'scale(1)';
    if (!isUserBtn) e.target.style.backgroundColor = 'white';
    else e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.15)';
  };

  return (
    <>
      <nav
        className="no-print"
        style={{
          backgroundColor: '#b30000',
          padding: isMobile ? '0.5rem 1rem' : '0.5rem 2rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          color: 'white',
          fontFamily: 'Arial, sans-serif',
          position: 'sticky',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
          <div 
            className="force-light-bg"
            style={logoContainerStyle}
            onClick={() => navigate('/')}
          >
            <img
              src={logo}
              alt="Archery Nexus Logó"
              style={{ 
                height: isMobile ? '35px' : '45px',
                width: 'auto', 
                display: 'block',
                marginTop: '4px'
              }} 
            />
          </div>

          <span
            style={{
              fontSize: isMobile ? '1.1rem' : '1.4rem',
              fontWeight: 'bold',
              color: 'white',
              cursor: 'pointer'
            }}
            onClick={() => navigate('/')}
          >
            ArcheryNexus
          </span>
        </div>

        {/* ASZTALI MENÜ */}
        {!isMobile && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '2rem' }}>
            <div style={{ display: 'flex', gap: '1.2rem', fontWeight: 'bold' }}>
              {currentUser && <Link to="/versenyek" style={{ color: 'white', textDecoration: 'none' }}>Versenyek</Link>}
              {currentUser && <Link to="/eredmenyek" style={{ color: 'white', textDecoration: 'none' }}>Eredmények</Link>}
              <Link to="/kapcsolat" style={{ color: 'white', textDecoration: 'none' }}>Kapcsolat</Link>
              <Link to="/adatvedelem" style={{ color: 'white', textDecoration: 'none' }}>Adatvédelem</Link>
            </div>

            <div style={{ display: 'flex', alignItems: 'center' }}>
              {currentUser ? (
                <>
                  <button
                    onClick={handleProfileNavigation}
                    style={userPageButtonStyle}
                    onMouseEnter={(e) => handleMouseEnter(e, true)}
                    onMouseLeave={(e) => handleMouseLeave(e, true)}
                    disabled={!userData}
                  >
                    🏹 {userData ? userData.displayName : "Betöltés..."}
                  </button>

                  <button
                    onClick={handleLogout}
                    style={buttonStyle}
                    onMouseEnter={(e) => handleMouseEnter(e, false)}
                    onMouseLeave={(e) => handleMouseLeave(e, false)}
                  >
                    Kijelentkezés
                  </button>
                </>
              ) : (
                <button
                  onClick={() => setShowLogin(true)}
                  style={buttonStyle}
                  onMouseEnter={(e) => handleMouseEnter(e, false)}
                  onMouseLeave={(e) => handleMouseLeave(e, false)}
                >
                  👤 Bejelentkezés
                </button>
              )}
            </div>
          </div>
        )}

        {/* MOBIL HAMBURGER GOMB */}
        {isMobile && (
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer', padding: '5px' }}
          >
            {mobileMenuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
          </button>
        )}
      </nav>

      {/* MOBIL LENYÍLÓ MENÜ */}
      {isMobile && mobileMenuOpen && (
        <div
          className="mobile-menu-light"
          style={{
            position: 'fixed',
            top: isMobile ? '55px' : '65px',
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 999,
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            gap: '5px'
          }}
        >
          {currentUser && (
            <>
              <Link to="/versenyek" onClick={() => setMobileMenuOpen(false)} style={{ color: '#333', textDecoration: 'none', fontSize: '1.1rem', fontWeight: 'bold', padding: '15px 0', borderBottom: '1px solid #ddd' }}>
                Versenyek
              </Link>
              <Link to="/eredmenyek" onClick={() => setMobileMenuOpen(false)} style={{ color: '#333', textDecoration: 'none', fontSize: '1.1rem', fontWeight: 'bold', padding: '15px 0', borderBottom: '1px solid #ddd' }}>
                Eredmények
              </Link>
            </>
          )}
          <Link to="/kapcsolat" onClick={() => setMobileMenuOpen(false)} style={{ color: '#333', textDecoration: 'none', fontSize: '1.1rem', fontWeight: 'bold', padding: '15px 0', borderBottom: '1px solid #ddd' }}>
            Kapcsolat
          </Link>
          <Link to="/adatvedelem" onClick={() => setMobileMenuOpen(false)} style={{ color: '#333', textDecoration: 'none', fontSize: '1.1rem', fontWeight: 'bold', padding: '15px 0', borderBottom: '1px solid #ddd' }}>
            Adatvédelem
          </Link>

          <div style={{ marginTop: '30px' }}>
            {currentUser ? (
              <>
                <button
                  onClick={handleProfileNavigation}
                  style={{ ...userPageButtonStyle, backgroundColor: '#b30000', color: 'white', border: 'none', marginBottom: '15px' }}
                >
                  🏹 {userData ? userData.displayName : "Profilom"}
                </button>

                <button
                  onClick={handleLogout}
                  style={{ ...buttonStyle, backgroundColor: '#eee', color: '#333', border: '1px solid #ccc' }}
                >
                  Kijelentkezés
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={() => setShowLogin(!showLogin)}
                  style={{ ...buttonStyle, backgroundColor: '#b30000', color: 'white' }}
                >
                  👤 {showLogin ? 'Bezárás' : 'Bejelentkezés'}
                </button>

                {showLogin && (
                  <LoginForm
                    isEmbedded={true}
                    onClose={() => {
                      setShowLogin(false);
                      setMobileMenuOpen(false);
                    }}
                  />
                )}
              </>
            )}
          </div>
        </div>
      )}

      {showLogin && !isMobile && <LoginForm onClose={() => setShowLogin(false)} />}
    </>
  );
};

export default Navbar;